import React, { useState } from 'react';
import { Layout } from 'antd';
import SideBarMenu from './Sidebar';
import UserProfileAvatar from '../common/UserProfileAvatar';
import logoWSB from '../../../public/WSB2.png';

const { Sider, Footer, Content } = Layout;

const backgroundColor = '#f4f7fc';

const footerStyle: React.CSSProperties = {
    background: backgroundColor,
    textAlign: 'center',
};

// Pin the sidebar to the viewport so its bottom is always the bottom of the
// screen. Without this the Sider stretches to the full page height, pushing the
// bottom-anchored user badge below the fold on long/scrolling pages (inbox,
// lessons) while it stayed visible on short ones.
const leftSiderStyle: React.CSSProperties = {
    backgroundColor: '#ffffff',
    height: '100vh',
    position: 'sticky',
    top: 0,
};

const contentStyle: React.CSSProperties = {
    backgroundColor: backgroundColor,
    paddingTop: '32px',
    paddingLeft: '40px',
    paddingRight: '40px',
};

const mainLayoutStyle: React.CSSProperties = {
    backgroundColor: backgroundColor,
    minHeight: '100vh',
};

// The Sider content is laid out as a full-height flex column so the user badge
// can be pinned to the bottom (above antd's collapse trigger) while the logo
// sits flush at the top and the menu fills the space between.
const siderInnerStyle: React.CSSProperties = {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
};

const logoStyle: React.CSSProperties = {
    width: '100%',
    height: 'auto',
    padding: '20px',
};

const menuWrapperStyle: React.CSSProperties = {
    flex: 1,
    overflowY: 'auto',
    minHeight: 0,
};

const userBadgeStyle: React.CSSProperties = {
    marginTop: 'auto',
    padding: '12px',
    // Clear antd's fixed 48px collapse trigger at the very bottom.
    paddingBottom: '64px',
};

const MainLayout = ({ children }) => {
    const [collapsed, setCollapsed] = useState(false);

    return (
        <Layout style={mainLayoutStyle}>
            <Sider
                collapsible
                collapsed={collapsed}
                onCollapse={(value) => setCollapsed(value)}
                style={leftSiderStyle}
                width={250}
            >
                <div style={siderInnerStyle}>
                    <img src={logoWSB} alt="logo" style={logoStyle} />

                    <div style={menuWrapperStyle}>
                        <SideBarMenu />
                    </div>

                    <div style={userBadgeStyle}>
                        <UserProfileAvatar collapsed={collapsed} />
                    </div>
                </div>
            </Sider>
            <Layout className="site-layout">
                <Content style={contentStyle}>{children}</Content>
                <Footer style={footerStyle} />
            </Layout>
        </Layout>
    );
};

export default MainLayout;
